$(function () {

    $('input.search').keypress(function (e) {

        var searchURL = $(this).data("search-page")
        if (e.which == 13) {

            var query = $(this).val();

            if ($.trim(query) != '' && query.length > 2) {
                window.location.href = searchURL + '?searchtext=' + HtmlStrip(query);
            }
            e.preventDefault();
        }
    });

    $('button.search').click(function (e) {

        var searchURL = $(this).data("search-page")


        var query = $("#keyword").val();

        if ($.trim(query) != '' && query.length > 2) {
            window.location.href = searchURL + '?searchtext=' + HtmlStrip(query);
        }
        e.preventDefault();

    });

    $('button.blogsearch').click(function (e) {

        var searchURL = $(this).data("search-page")


        var query = $("#keyword").val();

        if ($.trim(query) != '' && query.length > 2) {
            window.location.href = searchURL + '?s=' + HtmlStrip(query);
        }
        e.preventDefault();

    });
    $('input.blogsearch').keypress(function (e) {

        var searchURL = $(this).data("search-page")
        if (e.which == 13) {

            var query = $(this).val();

            if ($.trim(query) != '' && query.length > 2) {
                window.location.href = searchURL + '?s=' + HtmlStrip(query);
            }
            e.preventDefault();
        }
    });

    $('img.search').keypress(function (e) {
        var searchURL = $(this).data("search-page")
        if (e.which == 13) {

            var query = $(this).val();

            if ($.trim(query) != '' && query.length > 2) {
                window.location.href = searchURL + '?searchtext=' + HtmlStrip(query);
            }
            e.preventDefault();
        }
    });

    $('#quoteSearch').click(function (e) {
        var url = updateQueryStringParameter(window.location.href, "dateto", $('#dateto').val());
        url = updateQueryStringParameter(url, "datefrom", $('#datefrom').val());
        url = updateQueryStringParameter(url, "divisionid", $('#DivisionID :selected').val());
        //url = updateQueryStringParameter(url, "sourceid", $('#TUFilter :selected').val());
        window.location.href = url;
    });
    $('#chatSearch').click(function (e) {
        var url = updateQueryStringParameter(window.location.href, "dateto", $('#dateto').val());
        url = updateQueryStringParameter(url, "datefrom", $('#datefrom').val());
        window.location.href = url;
    });
});

function updateQueryStringParameter(uri, key, value) {
    var re = new RegExp("([?&])" + key + "=.*?(&|$)", "i");
    var separator = uri.indexOf('?') !== -1 ? "&" : "?";
    if (uri.match(re)) {
        return uri.replace(re, '$1' + key + "=" + value + '$2');
    }
    else {
        return uri + separator + key + "=" + value;
    }
}

function HtmlStrip(input) { var regex = /(<([^>]+)>)/ig; var result = input.replace(regex, ""); return result; }

// Read a page's GET URL variables and return them as an associative array.
function getUrlVars() {
    var vars = [], hash;
    var hashes = window.location.href.slice(window.location.href.indexOf('?') + 1).split('&');
    for (var i = 0; i < hashes.length; i++) {
        hash = hashes[i].split('=');
        vars.push(hash[0]);
        vars[hash[0]] = hash[1];
    }
    return vars;
}

function changeAttrOnWindowSize(selector, selector2, attrVal, attrVal2) {
    if (window.innerWidth < 768) {
        $(selector).attr('aria-hidden', attrVal)
        $(selector2).attr('aria-hidden', attrVal2)
    } else {
        $(selector).attr('aria-hidden', attrVal2)
        $(selector2).attr('aria-hidden', attrVal)
    }
}

changeAttrOnWindowSize(".quick-search-desktop", ".quick-search-mobile", true, false);

$(window).resize(function () {
    changeAttrOnWindowSize(".quick-search-desktop", ".quick-search-mobile", true, false);
})

$(document).ready(function () {
    //$(".quick-search-icon").click(function () {
    //    if ($(".search-container").hasClass("shown")) {
    //        $(".search-container").slideUp();
    //        $(".search-container").removeClass("shown");
    //        $(".search-container").addClass("hidden");
    //    }
    //    else {
    //        $(".search-container").slideDown();
    //        $(".search-container").addClass("shown");
    //        $(".search-container").removeClass("hidden");
    //    }

    //});
    $(".quick-search-icon").click(function () {
        $(".search-container").slideDown();
        $(".search-container").addClass("shown");
        $(".search-container").removeClass("hidden");
        $(this).hide();
        $(".search-x-icon").show();
    });

    $(".search-x-icon").click(function () {
        $(".search-container").slideUp();
        $(".search-container").removeClass("shown");
        $(".search-container").addClass("hidden");
        $(this).hide();
        $(".quick-search-icon").show();
    });
});